module.exports = __webpack_public_path__ + "static/RiskOfRain3-9f5e81754339386e1ed1bd7e57b9eb34.png";